import React from 'react'
import { storiesOf } from '@storybook/react'

import HowToDialog from 'components/HowToDialog'
import T from 'components/FormattedMessage'

import autosubIconUrl from 'components/AutoSub/components/AutoSubIntro/assets/autosub_symbol.svg'

storiesOf('HowToDialog', module)
  .add('dark', () => (
    <HowToDialog
      variant="dark"
      actionLabel={<T id="autosub_intro_back" />}
      onClose={() => { /**/ }}
      icon={<img src={autosubIconUrl} />}
      open
      displayNew
      headline="HowToDialog Dark with New"
      message={(
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit.
          Praesentium dignissimos reprehenderit tenetur rerum nesciunt
          harum saepe nihil, ab aliquam minima aut officiis iste debitis
          atque. Alias quo illo cumque debitis!
        </p>
      )}
    />
  ))
  .add('light', () => (
    <HowToDialog
      variant="light"
      actionLabel={<T id="autosub_intro_back" />}
      onClose={() => { /**/ }}
      icon={<img src={autosubIconUrl} />}
      open
      displayFAQ
      headline="HowToDialog Light with FAQ"
      message={(
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit.
          Praesentium dignissimos reprehenderit tenetur rerum nesciunt
          harum saepe nihil, ab aliquam minima aut officiis iste debitis
          atque. Alias quo illo cumque debitis!
        </p>
      )}
    />
  ))
